import { gsap } from 'gsap'

export class Loading {
  constructor() {
    this.kv = document.querySelector('.js-kv')
    this.cta = document.querySelector('.js-cta')

    this.body = document.body
    this.page = document.getElementById('page')
    this.header = document.getElementById('js-header')

    // falseでローディングスキップ
    this.isOpening = true

    // this.body.classList.add('is-fixed')
    // this.body.classList.add('is-loading')

    // gsap.to(this.page, {
    //   opacity: 1,
    //   duration: 1,
    // })

    if (this.isOpening === true) {
      this.kv = {
        el: this.kv,
        textArea: this.kv.querySelector('.p-index_kv__text-area'),
      }

      this.cta = {
        el: this.cta,
      }

      this.openingTl = gsap.timeline()

      gsap.set(this.kv.el, {
        opacity: 0,
      })
      gsap.set(this.kv.textArea, {
        opacity: 0,
        y: 20,
      })
      gsap.set(this.cta.el, {
        opacity: 0,
        y: 20,
      })

      gsap.set(this.header, {
        opacity: 0,
        y: -20,
      })

      this.playOpening()
    }
  }

  playOpening() {
    this.openingTl
      .to(
        this.kv.el,
        {
          opacity: 1,
          duration: 2,
          ease: 'power2.out',
        },
        '0',
      )
      .to(
        this.kv.textArea,
        {
          opacity: 1,
          scale: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          onStart: () => {
            this.kv.el.classList.add('is-text-act')
          },
        },
        '<0.5',
      )
      .to(
        this.cta.el,
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
        },
        '<0.5',
      )
      .to(
        this.header,
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
        },
        '<',
      )
  }
}
